import { render, staticRenderFns } from "./ConfirmPhoneViaCall.vue?vue&type=template&id=7d27da22&scoped=true&"
import script from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"
export * from "./ConfirmPhoneViaCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d27da22",
  null
  
)

export default component.exports